import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class DiagramService {

    diagramChanged: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
}